import { raise } from 'xstate';

import { createLogic as createControlActorLogic } from './actors/control/logic';
import type { FlowChildren } from './actors/types';
import { createLogic as createInferDecisionMakersLogic } from './operations/inferDecisionMakers/logic';
import { createLogic as createInferScopeLocationLogic } from './operations/inferScopeLocation/logic';
import type { OperationDeps } from './operations/types';
import { machine } from './orchestrationMachine';

/** Every variant actor's invoke id. Add new variants here. */
export const VARIANT_ACTOR_IDS = ['controlActorId'] as const satisfies ReadonlyArray<keyof FlowChildren>;

export const createLogic = (deps: OperationDeps) =>
	machine.provide({
		actors: {
			controlActorSrc: createControlActorLogic(),
			inferScopeLocationSrc: createInferScopeLocationLogic(deps),
			inferDecisionMakersSrc: createInferDecisionMakersLogic(deps),
		},
		guards: {
			canStartInferScopeLocation: ({ event }) =>
				event.type === 'job.start' &&
				event.name === 'inferScopeLocation' &&
				deps.featureConfigs.sapScopeLocationInference,
			canStartInferDecisionMakers: ({ event }) => event.type === 'job.start' && event.name === 'inferDecisionMakers',
		},
		actions: {
			raiseJobDone: raise((_, params) => ({ type: 'job.done', ...params })),
		},
	});
